export default __webpack_public_path__ + "static/media/nl.cfe72ae0.svg";